import { render, staticRenderFns } from "./portfolioCompanies.vue?vue&type=template&id=b4cf10d4&scoped=true&"
import script from "./portfolioCompanies.vue?vue&type=script&lang=js&"
export * from "./portfolioCompanies.vue?vue&type=script&lang=js&"
import style0 from "./portfolioCompanies.vue?vue&type=style&index=0&id=b4cf10d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf10d4",
  null
  
)

export default component.exports